"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextareaPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group${x => x.required ? ' required' : ''}">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label htmlFor="${x => x.name}" class="">${x => x.label.t()}</label>`)}
    <iframe 
        ${(0, fast_element_1.ref)('quillFrame')}
        class="quill-editor"
        style="width: 100%; height: 200px; border: 1px solid var(--brand-border); border-radius: 8px; resize: both;"
    ></iframe>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

.no-label {
  margin-left: 0;
}

.quill-editor {
  background-color: #FFF;
  resize: both;
  overflow: auto;
  min-height: 200px;
  border: 1px solid var(--brand-border);
  border-radius: 8px;
}`;
const shadowOptions = { "mode": "open" };
let RichTextareaPart = class RichTextareaPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = '';
        this.ignored = 'false';
        this.dontEmit = false;
        this.isInternalUpdate = false;
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setupQuill();
    }
    setupQuill() {
        if (this.quill) {
            return;
        }
        const iframe = this.getElement();
        if (!iframe) {
            return;
        }
        iframe.srcdoc = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <link href="https://cdn.jsdelivr.net/npm/quill@2.0.3/dist/quill.snow.css" rel="stylesheet" />
          <style>
            html, body { height: 100%; margin: 0; padding: 0; overflow: hidden; }
            #editor { height: 100%; display: flex; flex-direction: column; }
            .ql-container { flex: 1; overflow-y: auto; }
            .ql-editor { min-height: 0; padding-bottom: 24px; }
          </style>
        </head>
        <body>
          <div id="editor"></div>
          <script src="https://cdn.jsdelivr.net/npm/quill@2.0.3/dist/quill.js"></script>
          <script>
            window.quill = new Quill('#editor', {
              theme: 'snow',
              scrollingContainer: '.ql-container'
            });
          </script>
        </body>
      </html>
    `;
        iframe.onload = () => {
            const win = iframe.contentWindow;
            const quill = win.quill;
            if (!quill) {
                return;
            }
            if (this.value) {
                quill.root.innerHTML = this.value;
            }
            quill.on('text-change', () => {
                const html = quill.root.innerHTML;
                const value = html === '<p><br></p>' ? '' : html;
                this.isInternalUpdate = true;
                this.value = value;
                this.isInternalUpdate = false;
                this.handleChange({
                    target: {
                        value: this.value,
                        name: this.name
                    }
                });
            });
            this.quill = quill;
        };
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    getElement() {
        return this.$('.quill-editor');
    }
    valueChanged(old, newV) {
        if (this.isInternalUpdate || !this.quill || old === newV) {
            return;
        }
        const current = this.quill.root.innerHTML;
        const normalizedNewV = newV || '<p><br></p>';
        if (normalizedNewV !== current) {
            this.quill.root.innerHTML = normalizedNewV;
        }
    }
    reset() {
        if (this.quill) {
            this.quill.setContents([]);
        }
        this.value = '';
    }
};
exports.RichTextareaPart = RichTextareaPart;
RichTextareaPart.PART_TYPE = 'textarea';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "rows", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "cols", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RichTextareaPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RichTextareaPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RichTextareaPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RichTextareaPart.prototype, "quill", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], RichTextareaPart.prototype, "onChange", void 0);
exports.RichTextareaPart = RichTextareaPart = __decorate([
    (0, client_1.RWSView)('part-richtextarea', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RichTextareaPart);
RichTextareaPart.defineComponent();
